{
  "CONVERSATION": {
    "SELECT_A_CONVERSATION": "אנא בחר שיחה מהחלונית השמאלית",
    "CSAT_REPLY_MESSAGE": "נא דרג שיחה זו",
    "404": "מצטערים, לא מצאנו את השיחה המבוקשת, נא לנסות שוב",
    "SWITCH_VIEW_LAYOUT": "החלף תצוגה",
    "DASHBOARD_APP_TAB_MESSAGES": "הודעות",
    "UNVERIFIED_SESSION": "זהות המשתמש לא מְאוּמָתת",
    "NO_MESSAGE_1": "או - או! נראה שאין הודעות מלקוחות בתיבת הדואר הנכנס שלך.",
    "NO_MESSAGE_2": " לשלוח הודעה לעמוד שלך!",
    "NO_INBOX_1": "שלום! נראה שעדיין לא הוספת תיבות דואר נכנס.",
    "NO_INBOX_2": " להתחיל",
    "NO_INBOX_AGENT": "או - או! נראה שאתה לא חלק מתיבת דואר נכנס כלשהי. אנא פנה למנהל המערכת שלך",
    "SEARCH_MESSAGES": "חפש הודעות בשיחות",
    "VIEW_ORIGINAL": "הצג מקור",
    "VIEW_TRANSLATED": "הצג מתורגם",
    "EMPTY_STATE": {
      "CMD_BAR": "לפתיחת תפריט פקודות",
      "KEYBOARD_SHORTCUTS": "להצגת קיצורי מקלדת"
    },
    "SEARCH": {
      "TITLE": "חפש הודעות",
      "RESULT_TITLE": "תוצאות חיפוש",
      "LOADING_MESSAGE": "מחיקת נתונים...",
      "PLACEHOLDER": "הקלד כל טקסט כדי לחפש הודעות",
      "NO_MATCHING_RESULTS": "לא נמצאו תוצאות."
    },
    "UNREAD_MESSAGES": "הודעות שלא נקראו",
    "UNREAD_MESSAGE": "הודעות שלא נקראו",
    "CLICK_HERE": "לחץ כאן",
    "LOADING_INBOXES": "טוען תיבות דואר נכנס",
    "LOADING_CONVERSATIONS": "טוען שיחות",
    "CANNOT_REPLY": "לא ניתן להשיב עקב",
    "24_HOURS_WINDOW": "הגבלת חלון הודעות של 24 שעות",
    "48_HOURS_WINDOW": "הגבלת חלון הודעות של 48 שעות",
    "API_HOURS_WINDOW": "תוכל להשיב לשיחה זו רק תוך {hours} שעות",
    "NOT_ASSIGNED_TO_YOU": "השיחה לא שייכת לך, האם תרצה לשייך אותה אליך?",
    "ASSIGN_TO_ME": "שייך לעצמך",
    "BOT_HANDOFF_MESSAGE": "אתה משיב לשיחה שמטופלת כרגע על ידי עוזר או בוט.",
    "BOT_HANDOFF_ACTION": "סמן כפתוח והקצה לעצמך",
    "BOT_HANDOFF_REOPEN_ACTION": "סמן שיחה כפתוחה",
    "BOT_HANDOFF_SUCCESS": "השיחה הועברה אליך",
    "BOT_HANDOFF_ERROR": "ההשתלטות על השיחה נכשלה. אנא נסה שוב.",
    "TWILIO_WHATSAPP_CAN_REPLY": "אתה יכול להשיב לשיחה זו רק באמצעות הודעת תבנית בשל",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "הגבלת חלון הודעות של 24 שעות",
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. All new messages will show up there. You won’t be able to send messages from this conversation anymore.",
    "INSTAGRAM_RESTRICTION_BANNER": "Instagram is currently restricted. Some messages or actions may be delayed or unavailable while we restore full support.",
    "INSTAGRAM_RESTRICTION_STATUS_LINK": "View status update",
    "REPLYING_TO": "אתה משיב ל:",
    "REMOVE_SELECTION": "הסר בחירה",
    "DOWNLOAD": "הורד",
    "UNKNOWN_FILE_TYPE": "קובץ לא ידוע",
    "SAVE_CONTACT": "שמור איש קשר",
    "NO_CONTENT": "אין תוכן להצגה",
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} שיתף/ה איש קשר",
      "LOCATION": "{sender} שיתף/ה מיקום",
      "FILE": "{sender} שיתף/ה קובץ",
      "MEETING": "{sender} התחיל/ה פגישה"
    },
    "UPLOADING_ATTACHMENTS": "מעלה קובץ מצורף...",
    "REPLIED_TO_STORY": "השיב/ה לסטורי שלך",
    "UNSUPPORTED_MESSAGE": "This message is unsupported. You can view this message on the Facebook / Instagram app.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "הודעה זו אינה נתמכת. תוכל לצפות בהודעה זו באפליקציית Facebook Messenger.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "הודעה זו אינה נתמכת. תוכל לצפות בהודעה זו באפליקציית Instagram.",
    "UNSUPPORTED_MESSAGE_TIKTOK": "This message is unsupported. You can view this message on the TikTok app.",
    "UNSUPPORTED_MESSAGE_WHATSAPP": "This message is unsupported. You can view this message on the WhatsApp app.",
    "SUCCESS_DELETE_MESSAGE": "ההודעה נמחקה בהצלחה",
    "FAIL_DELETE_MESSSAGE": "לא ניתן למחוק את ההודעה! נסה שוב",
    "NO_RESPONSE": "אין תגובה",
    "RESPONSE": "תגובה",
    "RATING_TITLE": "דירוג",
    "FEEDBACK_TITLE": "משוב",
    "REPLY_MESSAGE_NOT_FOUND": "ההודעה אינה זמינה",
    "CARD": {
      "SHOW_LABELS": "הצג תויות",
      "HIDE_LABELS": "הסתר תוויות",
      "LABELS_COUNT": "{count} labels"
    },
    "VOICE_CALL": {
      "INCOMING_CALL": "שיחה נכנסת",
      "OUTGOING_CALL": "שיחה יוצאת",
      "CALL_IN_PROGRESS": "שיחה מתבצעת",
      "NO_ANSWER": "אין מענה",
      "NO_ANSWER_OUTBOUND_LABEL": "אין מענה",
      "NO_ANSWER_OUTBOUND_SUBTEXT": "Contact didn't pick up",
      "MISSED_CALL": "שיחה שלא נענתה",
      "MISSED_CALL_INBOUND_SUBTEXT": "No agent picked up",
      "MISSED_CALL_DECLINED_BY": "Declined by {agentName}",
      "CALL_ENDED": "השיחה הסתיימה",
      "HANDLED_BY": "Handled by {agentName}",
      "NOT_ANSWERED_YET": "עדיין לא נענה",
      "CALLING": "Calling…",
      "THEY_ANSWERED": "הם ענו",
      "YOU_ANSWERED": "אתה ענית",
      "AGENT_ANSWERED": "{agentName} answered",
      "JOIN_CALL": "Join call",
      "CALL_BACK": "Call back",
      "TRANSCRIPT_SHOW_MORE": "Show more",
      "TRANSCRIPT_SHOW_LESS": "Show less"
    },
    "HEADER": {
      "RESOLVE_ACTION": "פתרון",
      "REOPEN_ACTION": "פתח מחדש",
      "OPEN_ACTION": "פתח",
      "MORE_ACTIONS": "פעולות נוספות",
      "OPEN": "עוד",
      "CLOSE": "סגור",
      "DETAILS": "פרטים",
      "COPY_ID_SUCCESS": "Conversation ID copied to clipboard",
      "SNOOZED_UNTIL": "מושתק עד",
      "SNOOZED_UNTIL_TOMORROW": "נמנם עד מחר",
      "SNOOZED_UNTIL_NEXT_WEEK": "נמנם עד שבוע הבא",
      "SNOOZED_UNTIL_NEXT_REPLY": "נמנם עד תגובה הבאה",
      "WHATSAPP_CALL": "Start WhatsApp call",
      "WHATSAPP_CALL_FAILED": "Could not start the WhatsApp call.",
      "VOICE_CALL": "Start call",
      "VOICE_CALL_FAILED": "Could not start the call.",
      "WHATSAPP_CALL_PERMISSION_REQUESTED": "Sent a call permission request to the contact. Try again once they accept.",
      "WHATSAPP_CALL_PERMISSION_PENDING": "Call permission request already sent recently. Try again once the contact accepts.",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "הוחמץ",
        "DUE": "עקב"
      }
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "סמן כממתין",
      "SNOOZE_UNTIL": "נודניק",
      "SNOOZE": {
        "TITLE": "השהה עד",
        "NEXT_REPLY": "תגובה הבאה",
        "TOMORROW": "מחר",
        "NEXT_WEEK": "שבוע הבא"
      }
    },
    "MENTION": {
      "AGENTS": "סוכנים",
      "TEAMS": "צוותים"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "השהה עד",
      "APPLY": "נודניק",
      "CANCEL": "ביטול"
    },
    "PRIORITY": {
      "TITLE": "עדיפות",
      "OPTIONS": {
        "NONE": "כלום",
        "URGENT": "דחוף",
        "HIGH": "גבוהה",
        "MEDIUM": "בינונית",
        "LOW": "נמוכה"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "כלום",
        "INPUT_PLACEHOLDER": "בחר עדיפות",
        "NO_RESULTS": "לא נמצאו תוצאות",
        "SUCCESSFUL": "העדיפות של שיחה מזהה {conversationId} שונתה ל- {priority}",
        "FAILED": "לא ניתן לשנות עדיפות. אנא נסה שוב."
      }
    },
    "DELETE_CONVERSATION": {
      "TITLE": "מחק שיחה #{conversationId}",
      "DESCRIPTION": "האם אתה בטוח שברצונך למחוק שיחה זו?",
      "CONFIRM": "מחק"
    },
    "CARD_CONTEXT_MENU": {
      "PENDING": "סמן כממתין",
      "RESOLVED": "סמן כפתור",
      "MARK_AS_UNREAD": "סמן כלא נקרא",
      "MARK_AS_READ": "סמן כנקרא",
      "REOPEN": "פתח מחדש את השיחה",
      "SNOOZE": {
        "TITLE": "נודניק",
        "NEXT_REPLY": "עד תגובה הבאה",
        "TOMORROW": "עד מחר",
        "NEXT_WEEK": "עד שבוע הבא"
      },
      "ASSIGN_AGENT": "שייך סוכן",
      "ASSIGN_LABEL": "ההקצה תווית",
      "AGENTS_LOADING": "טוען סוכנים...",
      "ASSIGN_TEAM": "שייך צוות",
      "DELETE": "מחק שיחה",
      "OPEN_IN_NEW_TAB": "פתח בכרטיסייה חדשה",
      "COPY_LINK": "העתק קישור לשיחה",
      "COPY_LINK_SUCCESS": "קישור השיחה הועתק ללוח",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "מזהה שיחה {conversationId} קושר ל {agentName}",
          "FAILED": "השמת הסוכן לא הצליחה. בבקשה נסה שנית."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "הוקצתה תווית #{labelName} לשיחה מזהה {conversationId}",
          "FAILED": "לא ניתן לקשר שורה. אנא נסו שנית"
        },
        "LABEL_REMOVAL": {
          "SUCCESFUL": "Removed label #{labelName} from conversation id {conversationId}",
          "FAILED": "Couldn't remove label. Please try again."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "הצוות {team} קושר לשיחה מספר {conversationId}",
          "FAILED": "השמה לצוות לא הצליחה, בבקשה נסה שנית."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "חתימת הודעה",
      "ENABLE_SIGN_TOOLTIP": "אפשר חתימה",
      "DISABLE_SIGN_TOOLTIP": "נטרל חתימה",
      "MSG_INPUT": "Shift + Enter עבור שורה חדשה. התחל עם '/' כדי לבחור תגובה מוכנה.",
      "PRIVATE_MSG_INPUT": "Shift + Enter עבור שורה חדשה. זה יהיה גלוי רק לסוכנים",
      "MESSAGING_RESTRICTED": "You cannot reply to this conversation",
      "MESSAGING_RESTRICTED_WHATSAPP": "You can only reply using a template message due to 24-hour message window restriction",
      "MESSAGING_RESTRICTED_API": "You can only reply using a template message due to message window restriction",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "חתימת הודעה אינה מוגדרת, נא הגדר אותה בהגדרות הפרופיל.",
      "COPILOT_MSG_INPUT": "תן ל-Copilot הנחיות נוספות, או שאל משהו נוסף... לחץ אנטר כדי לשלוח המשך",
      "CLICK_HERE": "לחץ כאן כדי לעדכן",
      "WHATSAPP_TEMPLATES": "תבניות וואטסאפ"
    },
    "REPLYBOX": {
      "REPLY": "הגב",
      "PRIVATE_NOTE": "הערה פרטית",
      "SEND": "שלח",
      "CREATE": "הוסף הערה",
      "INSERT_READ_MORE": "קרא עוד",
      "DISMISS_REPLY": "בטל תגובה",
      "REPLYING_TO": "משיב/ה ל:",
      "TIP_EMOJI_ICON": "הצג בחירת אימוג'ים",
      "TIP_ATTACH_ICON": "הוסף קבצים",
      "TIP_AUDIORECORDER_ICON": "הקלט אודיו",
      "TIP_AUDIORECORDER_PERMISSION": "אפשר גישה לאודיו",
      "TIP_AUDIORECORDER_ERROR": "לא יכול לפתוח אודיו",
      "AUDIO_CONVERSION_FAILED": "Audio conversion failed. Please try again.",
      "DRAG_DROP": "גרור ושחרר כאן להוספת קובץ מצורף",
      "IMAGE_UPLOAD_SUCCESS": "התמונה הועלתה בהצלחה",
      "START_AUDIO_RECORDING": "התחל הקלטת אודיו",
      "STOP_AUDIO_RECORDING": "עצור הקלטת אודיו",
      "COPILOT_THINKING": "Copilot חושב",
      "EMAIL_HEAD": {
        "TO": "אל",
        "ADD_BCC": "הוסף bcc",
        "CC": {
          "LABEL": "עותק",
          "PLACEHOLDER": "אימיילים מופרדים בפסיקים",
          "ERROR": "בבקשה הכנס כתוכת אימייל"
        },
        "BCC": {
          "LABEL": "עותק מוסתר",
          "PLACEHOLDER": "אימיילים מופרדים בפסיקים",
          "ERROR": "בבקשה הכנס כתוכת אימייל"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "משתנים בלתי מזוהים",
        "MESSAGE": "יש לך {undefinedVariablesCount} משתנים בלתי מזוהים בהודעה {undefinedVariables}. תרצה לשלוח את ההודעה בכל זאת?",
        "CONFIRM": {
          "YES": "שלח",
          "CANCEL": "ביטול"
        }
      },
      "QUOTED_REPLY": {
        "ENABLE_TOOLTIP": "כלול שרשור דוא\"ל מצוטט",
        "DISABLE_TOOLTIP": "אל תכלול שרשור דוא\"ל מצוטט",
        "REMOVE_PREVIEW": "הסר שרשור דוא\"ל מצוטט",
        "COLLAPSE": "כווץ תצוגה מקדימה",
        "EXPAND": "הרחב תצוגה מקדימה"
      }
    },
    "VISIBLE_TO_AGENTS": "פתקים פרטיים: רק אתה והצוות שלך יכולים לראות",
    "CHANGE_STATUS": "סטטוס השיחה השתנה",
    "CHANGE_STATUS_FAILED": "סטטוס השיחה השתנה לנכשלה",
    "CHANGE_AGENT": "שיוך שיחה השתנתה",
    "CHANGE_AGENT_FAILED": "שינוי קישור נכשל",
    "ASSIGN_LABEL_SUCCESFUL": "סמן משימה כבוצעה בהצלחה",
    "ASSIGN_LABEL_FAILED": "סמן משימה כנכשלה",
    "CHANGE_TEAM": "שיחת קבוצה השתנתה",
    "SUCCESS_DELETE_CONVERSATION": "השיחה נמחקה בהצלחה",
    "FAIL_DELETE_CONVERSATION": "לא ניתן למחוק את השיחה! נסה שוב",
    "FILE_SIZE_LIMIT": "הקובץ גדול מ{MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE}MB מגבלת העלאה",
    "FILE_TYPE_NOT_SUPPORTED": "This {fileName} file type is not supported in this conversation",
    "MESSAGE_ERROR": "לא ניתן לשלוח הודעה, אנא נסה שוב מאוחר יותר",
    "SENT_BY": "נשלח על ידי:",
    "BOT": "בוט",
    "NATIVE_APP": "Native app",
    "NATIVE_APP_ADVISORY": "This message was sent from the native app. Reply from Chatwoot to maintain the message window.",
    "SEND_FAILED": "לא ניתן לשלוח הודעה! נסה שוב",
    "TRY_AGAIN": "נסה שוב",
    "ASSIGNMENT": {
      "SELECT_AGENT": "בחר סוכן",
      "REMOVE": "הסר",
      "ASSIGN": "שייך"
    },
    "CONTEXT_MENU": {
      "COPY": "העתק",
      "REPLY_TO": "השב להודעה זו",
      "DELETE": "מחק",
      "CREATE_A_CANNED_RESPONSE": "הוסף לתגובות מוכנות",
      "TRANSLATE": "תרגום",
      "COPY_PERMALINK": "העתק קישור להודעה",
      "LINK_COPIED": "קישור להודעה הועתק ללוח",
      "DELETE_CONFIRMATION": {
        "TITLE": "בטוחים שאתם רוצים למחוק את ההודעה הזו?",
        "MESSAGE": "לא ניתן לבטל פעולה זו",
        "DELETE": "מחק",
        "CANCEL": "ביטול"
      },
      "REPORT_MESSAGE": {
        "LABEL": "Report message",
        "TITLE": "Report Captain message",
        "DESCRIPTION": "Found an issue with this AI response? Let us know what went wrong and our team will review it to help improve Captain's accuracy.",
        "PROBLEM_TYPE": "Problem type",
        "PROBLEM_TYPE_PLACEHOLDER": "Select a problem type",
        "DESCRIPTION_LABEL": "תיאור",
        "DESCRIPTION_PLACEHOLDER": "Describe the problem in detail",
        "SUBMIT": "Report",
        "SUCCESS": "Thanks for reporting. Our team will take a look.",
        "ERROR": "Could not report this message. Please try again.",
        "REASONS": {
          "incorrect_information": "Incorrect information",
          "inappropriate_response": "Inappropriate response",
          "incomplete_response": "Incomplete response",
          "outdated_information": "Outdated information",
          "other": "Other"
        }
      }
    },
    "SIDEBAR": {
      "CONTACT": "איש קשר",
      "COPILOT": "טייס משנה"
    },
    "VOICE_WIDGET": {
      "INCOMING_CALL": "שיחה נכנסת",
      "OUTGOING_CALL": "שיחה יוצאת",
      "CALL_IN_PROGRESS": "שיחה מתבצעת",
      "NOT_ANSWERED_YET": "עדיין לא נענה",
      "HANDLED_IN_ANOTHER_TAB": "Being handled in another tab",
      "REJECT_CALL": "Reject",
      "DISMISS_CALL": "סגור",
      "JOIN_CALL": "Join call",
      "END_CALL": "End call",
      "MUTE": "Mute mic",
      "UNMUTE": "Unmute mic",
      "VIEW_CHAT_HISTORY": "View chat history",
      "GO_TO_CONVERSATION": "Go to conversation thread"
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "שלח תמליל של השיחה",
    "DESC": "שלח את תמליל השיחה למייל ספציפי",
    "SUBMIT": "שלח",
    "CANCEL": "ביטול",
    "SEND_EMAIL_SUCCESS": "תמליל השיחה נשלח בהצלחה",
    "SEND_EMAIL_ERROR": "היתה שגיאה, בקשה נסה שוב",
    "SEND_EMAIL_PAYMENT_REQUIRED": "Email transcript is not available on your current plan. Please upgrade to use this feature.",
    "FORM": {
      "SEND_TO_CONTACT": "שלח תמליל ללקוח",
      "SEND_TO_AGENT": "שלח תמליל לסוכן המשוייך לשיחה",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "שלח תמליל לאימייל אחר",
      "EMAIL": {
        "PLACEHOLDER": "הכנס כתובת אימייל",
        "ERROR": "בבקשה הכנס כתוכת אימייל תקינה"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "היי 👋, ברוך הבא ל{installationName}!",
    "DESCRIPTION": "תודה על ההרשמה. אנחנו רוצים לתת לך את הכי הרבה מ {installationName}. הינה כמה דברים שאתה יכול לעשות עם {installationName} לחוויה טובה.",
    "GREETING_MORNING": "👋 Good morning, {name}. Welcome to {installationName}.",
    "GREETING_AFTERNOON": "👋 Good afternoon, {name}. Welcome to {installationName}.",
    "GREETING_EVENING": "👋 Good evening, {name}. Welcome to {installationName}.",
    "READ_LATEST_UPDATES": "תקרא את העדכונים אחרונים",
    "ALL_CONVERSATION": {
      "TITLE": "כל השיחות שלך במקום אחד",
      "DESCRIPTION": "צפה בכל השיחות שלך עם הלקוחות בדאשבורד אחד. אתה יכול לסנן את השיחות לפי הערוץ, התווית והסטטוס.",
      "NEW_LINK": "לחץ כאן כדי ליצור תיבה"
    },
    "TEAM_MEMBERS": {
      "TITLE": "הזמן את חברי הצוות שלך",
      "DESCRIPTION": "מאחר ואתם מוכנים לדבר עם הלקוח, הביאו את חברי הצוות שלכם לעזור לכם. תוכלו להזמין חברי צוות על ידי הוספה של כתובת הדוא\"ל שלהם לרשימת הסוכנים.",
      "NEW_LINK": "לחץ כאן כדי להזמין חבר צוות"
    },
    "LABELS": {
      "TITLE": "ארגן שיחות עם תוויות",
      "DESCRIPTION": "תוויות מספקות דרך קלה יותר לסווג את השיחה שלך. צור כמה תוויות כמו #support-enquiry, #billing-question וכו', כדי שתוכל להשתמש בהן בשיחה מאוחר יותר.",
      "NEW_LINK": "לחץ כאן כדי ליצור תגיות"
    },
    "CANNED_RESPONSES": {
      "TITLE": "צור תבניות תגובה מוכנות\n\n",
      "DESCRIPTION": "תבניות תגובה מוכנות מראש מאפשרות לך להגיב במהירות לשיחה. הסוכנים יכולים להקליד את התו '/' ואחריו קוד קצר כדי להוסיף תגובה.",
      "NEW_LINK": "לחץ כאן כדי ליצור תבנית תגובה מוכנה"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "סוכן מוקצה",
    "SELF_ASSIGN": "קשר אלי",
    "TEAM_LABEL": "צוות משוייך",
    "SELECT": {
      "PLACEHOLDER": "כלום"
    },
    "ACCORDION": {
      "CONTACT_DETAILS": "פרטי איש קשר",
      "CONVERSATION_ACTIONS": "פעולות בשיחה",
      "CONVERSATION_LABELS": "תוויות שיחה",
      "CONVERSATION_INFO": "מידע על שיחה",
      "CONTACT_NOTES": "הערות איש קשר",
      "CONTACT_ATTRIBUTES": "תכונות יצירת קשר",
      "PREVIOUS_CONVERSATION": "שיחות קודמות",
      "MACROS": "מאקרו",
      "LINEAR_ISSUES": "בעיות Linear מקושרות",
      "SHOPIFY_ORDERS": "הזמנות Shopify",
      "SHARED_FILES": "Attachments"
    },
    "SHARED_FILES": {
      "EMPTY": "No attachments yet",
      "DOWNLOAD": "Download file",
      "DOWNLOAD_ERROR": "Could not download the file. Please try again.",
      "MEDIA_HEADING": "מדיה",
      "FILES_HEADING": "Files",
      "VIEW_ALL": "הצג הכל",
      "SHOW_LESS": "Show less",
      "MORE_COUNT": "+{count}",
      "UNTITLED_FILE": "Untitled file",
      "JUMP_TO_MESSAGE": "Jump to message"
    },
    "SHOPIFY": {
      "ORDER_ID": "הזמנה #{id}",
      "ERROR": "שגיאה בטעינת הזמנות",
      "NO_SHOPIFY_ORDERS": "לא נמצאו הזמנות",
      "FINANCIAL_STATUS": {
        "PENDING": "ממתין ל",
        "AUTHORIZED": "מאושר",
        "PARTIALLY_PAID": "שולם חלקית",
        "PAID": "שולם",
        "PARTIALLY_REFUNDED": "הוחזר חלקית",
        "REFUNDED": "הוחזר",
        "VOIDED": "בוטל"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "מולא",
        "PARTIALLY_FULFILLED": "מולא חלקית",
        "UNFULFILLED": "לא מולא"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "צור תכונה",
    "NO_RECORDS_FOUND": "לא נמצאו מאפיינים",
    "UPDATE": {
      "SUCCESS": "המאפיין עודכן בהצלחה",
      "ERROR": "לא ניתן לעדכן את המאפיין. בבקשה נסה שוב מאוחר יותר"
    },
    "ADD": {
      "TITLE": "הוסף",
      "SUCCESS": "מאפיין נוסף בהצלחה",
      "ERROR": "לא ניתן היה ליצור מאפיין, אנא נסה שוב מאוחר יותר"
    },
    "DELETE": {
      "SUCCESS": "המאפיין נמחק בהצלחה",
      "ERROR": "לא ניתן למחוק מאפיין. בבקשה נסה שוב מאוחר יותר"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "הוסף מאפיין",
      "PLACEHOLDER": "חפש מאפיין",
      "NO_RESULT": "לא נמצאו מאפיינים"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "מאת",
    "TO": "אל",
    "BCC": "עותק מוסתר",
    "CC": "עותק",
    "SUBJECT": "נושא",
    "EXPAND": "הרחב דוא\"ל"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "משתתף",
    "SIDEBAR_TITLE": "משתתפים בשיחה",
    "NO_RECORDS_FOUND": "לא נמצאו תוצאות",
    "ADD_PARTICIPANTS": "בחר משתתפים",
    "REMANING_PARTICIPANTS_TEXT": "+{count} אחרים",
    "REMANING_PARTICIPANT_TEXT": "+{count} אחר",
    "TOTAL_PARTICIPANTS_TEXT": "{count} אנשים משתתפים.",
    "TOTAL_PARTICIPANT_TEXT": "{count} אדם משתתף.",
    "NO_PARTICIPANTS_TEXT": "אף אחד לא משתתף!.",
    "WATCH_CONVERSATION": "הצטרף לשיחה",
    "YOU_ARE_WATCHING": "אתה משתתף",
    "API": {
      "ERROR_MESSAGE": "לא ניתן היה לעדכן, נסה שוב!",
      "SUCCESS_MESSAGE": "המשתתפים עודכנו!"
    }
  },
  "TRANSLATE_MODAL": {
    "TITLE": "הצג תוכן מתורגם",
    "DESC": "תוכל לראות את התוכן המתורגם בכל שפה.",
    "ORIGINAL_CONTENT": "תוכן מקורי",
    "TRANSLATED_CONTENT": "תוכן מתורגם",
    "NO_TRANSLATIONS_AVAILABLE": "אין תרגומים זמינים לתוכן זה"
  },
  "TYPING": {
    "ONE": "{user} מקליד/ה",
    "TWO": "{user} ו-{secondUser} מקלידים",
    "MULTIPLE": "{user} ו {count} משתמשים אחרים מקלידים"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "נסה הנחיות אלה"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "לא ניתן להוריד קובץ מצורף. אנא נסה שוב"
  }
}
